<template lang="pug">
  .tab-content
    p.blurb {{__('Select a featured gym below to view its product details or use it as a template for your own layout.')}}
    .grid
      CallToAction.gym(
        v-for="project in featured"
        :key="project._id"
        :background="{src: project.render, link: '/zeus-builder/project/'+project._id}"
        :title="project.name"
        :subtitle="project.customerId")
</template>
<script setup lang="ts">
import { FEATURED } from '@/js/pages/gym-builder/data'

const featured = Object.freeze(FEATURED)
</script>
